// Put your application javascript here
window.api = {
    category:"http://shopify.laborsing.com/api/get/category",
}
jQuery.fn.wait = function (selector, func, times, interval) {
    var _times = times || -1, //100次
        _interval = interval || 20, //20毫秒每次
        _self = this,
        _selector = selector, //选择器
        _iIntervalID; //定时器id
    if( this.length ){ //如果已经获取到了，就直接执行函数
        func && func.call(this);
    } else {
        _iIntervalID = setInterval(function() {
            if(!_times) { //是0就退出
                clearInterval(_iIntervalID);
            }
            _times <= 0 || _times--; //如果是正数就 --

            _self = $(_selector); //再次选择
            if( _self.length ) { //判断是否取到
                func && func.call(_self);
                clearInterval(_iIntervalID);
            }
        }, _interval);
    }
    return this;
}




// tmp 函数初始化
function tmp(strings, ...args) {
    let result = ``;
    const appends = {};
    for (let i = 0; i < args.length; i++) {
        if (args[i] instanceof HTMLElement) {
            const id = `id${i}`;
            appends[id] = args[i];
            result += `${strings[i]}<div append="${id}"></div>`;
        } else {
            result += strings[i] + args[i];
        }
    }
    result += strings[strings.length - 1];

    const template = document.createElement(`template`);
    template.innerHTML = result;

    const content = template.content;

    [...content.querySelectorAll(`[append]`)].forEach(refNode => {
        const newNode = appends[refNode.getAttribute('append')];
        refNode.parentNode.insertBefore(newNode, refNode);
        refNode.parentNode.removeChild(refNode);
    });

    content.collect = ({ attr = 'ref', keepAttribute, to = {} } = {}) => {
        const refElements = content.querySelectorAll(`[${attr}]`);
        return [...refElements].reduce((acc, element) => {
            const propName = element.getAttribute(attr).trim();
            !keepAttribute && element.removeAttribute(attr);
            acc[propName] = acc[propName]
                ? Array.isArray(acc[propName])
                    ? [...acc[propName], element]
                    : [acc[propName], element]
                : element;
            return acc;
        }, to);
    };

    return content;
}
$(function (){
    // 隐藏客服按钮
    if(window.platform === 'mobile')
    {
        $('#shopify-chat').wait('#shopify-chat',function (){
            $('#shopify-chat').addClass('hidden');
        })
    }

    var loadingShow = function (){
        var dom = tmp`
            <div id="loading" v-show="loading">
                <div class="loading-spiner">
                <?xml version="1.0" encoding="utf-8"?><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="80px" height="80px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="margin-right:-2px;display:block;background-repeat-y:initial;background-repeat-x:initial;animation-play-state:paused" ><g transform="rotate(0 50 50)" style="transform:matrix(1, 0, 0, 1, 0, 0);animation-play-state:paused" ><rect x="48.5" y="23" rx="0.5" ry="0.5" width="3" height="10" fill="#ffffff" opacity="0.083334" style="opacity:0.083334;animation-play-state:paused" ></rect></g>
                <g transform="rotate(30 50 50)" style="transform:matrix(0.866025, 0.5, -0.5, 0.866025, 31.6987, -18.3013);animation-play-state:paused" ><rect x="48.5" y="23" rx="0.5" ry="0.5" width="3" height="10" fill="#ffffff" opacity="0.166667" style="opacity:0.166667;animation-play-state:paused" ></rect></g>
                <g transform="rotate(60 50 50)" style="transform:matrix(0.5, 0.866025, -0.866025, 0.5, 68.3013, -18.3013);animation-play-state:paused" ><rect x="48.5" y="23" rx="0.5" ry="0.5" width="3" height="10" fill="#ffffff" opacity="0.25" style="opacity:0.25;animation-play-state:paused" ></rect></g>
                <g transform="rotate(90 50 50)" style="transform:matrix(6.12323e-17, 1, -1, 6.12323e-17, 100, 0);animation-play-state:paused" ><rect x="48.5" y="23" rx="0.5" ry="0.5" width="3" height="10" fill="#ffffff" opacity="0.333334" style="opacity:0.333334;animation-play-state:paused" ></rect></g>
                <g transform="rotate(120 50 50)" style="transform:matrix(-0.5, 0.866025, -0.866025, -0.5, 118.301, 31.6987);animation-play-state:paused" ><rect x="48.5" y="23" rx="0.5" ry="0.5" width="3" height="10" fill="#ffffff" opacity="0.416667" style="opacity:0.416667;animation-play-state:paused" ></rect></g>
                <g transform="rotate(150 50 50)" style="transform:matrix(-0.866025, 0.5, -0.5, -0.866025, 118.301, 68.3013);animation-play-state:paused" ><rect x="48.5" y="23" rx="0.5" ry="0.5" width="3" height="10" fill="#ffffff" opacity="0.5" style="opacity:0.5;animation-play-state:paused" ></rect></g>
                <g transform="rotate(180 50 50)" style="transform:matrix(-1, 1.22465e-16, -1.22465e-16, -1, 100, 100);animation-play-state:paused" ><rect x="48.5" y="23" rx="0.5" ry="0.5" width="3" height="10" fill="#ffffff" opacity="0.583334" style="opacity:0.583334;animation-play-state:paused" ></rect></g>
                <g transform="rotate(210 50 50)" style="transform:matrix(-0.866025, -0.5, 0.5, -0.866025, 68.3013, 118.301);animation-play-state:paused" ><rect x="48.5" y="23" rx="0.5" ry="0.5" width="3" height="10" fill="#ffffff" opacity="0.666667" style="opacity:0.666667;animation-play-state:paused" ></rect></g>
                <g transform="rotate(240 50 50)" style="transform:matrix(-0.5, -0.866025, 0.866025, -0.5, 31.6987, 118.301);animation-play-state:paused" ><rect x="48.5" y="23" rx="0.5" ry="0.5" width="3" height="10" fill="#ffffff" opacity="0.75" style="opacity:0.75;animation-play-state:paused" ></rect></g>
                <g transform="rotate(270 50 50)" style="transform:matrix(-1.83697e-16, -1, 1, -1.83697e-16, 7.10543e-15, 100);animation-play-state:paused" ><rect x="48.5" y="23" rx="0.5" ry="0.5" width="3" height="10" fill="#ffffff" opacity="0.833334" style="opacity:0.833334;animation-play-state:paused" ></rect></g>
                <g transform="rotate(300 50 50)" style="transform:matrix(0.5, -0.866025, 0.866025, 0.5, -18.3013, 68.3013);animation-play-state:paused" ><rect x="48.5" y="23" rx="0.5" ry="0.5" width="3" height="10" fill="#ffffff" opacity="0.916667" style="opacity:0.916667;animation-play-state:paused" ></rect></g>
                <g transform="rotate(330 50 50)" style="transform:matrix(0.866025, -0.5, 0.5, 0.866025, -18.3013, 31.6987);animation-play-state:paused" ><rect x="48.5" y="23" rx="0.5" ry="0.5" width="3" height="10" fill="#ffffff" opacity="1" style="animation-play-state:paused" ></rect></g><!-- generated by https://loading.io/ --></svg>
                </div>
            </div>
        `
        document.body.append(dom)
    }
    var loadingHide = function (){
        document.getElementById('loading').remove()
    }

    var msgSuccess = function (title,type){
        var dom = tmp`
            <div id="message-success">
                <div class="message-success-wrapper ${type}-wrapper">
                    <img class="${type}-img" src="data:image/png;base64,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" alt="">
                    <div class="${type}-title">${title}</div>
                </div>
            </div>
        `;
        document.body.append(dom)
        setTimeout(function (){
            document.getElementById('message-success').remove()
        },1500)
    }
    var msgError = function (title,type){
        var dom = tmp`
            <div id="message-success">
                <div class="message-success-wrapper ${type}-wrapper">
                    <img class="${type}-img" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAKgUlEQVR4Xu2df4xUVxXHv+ftvmV2dwZoMdGYWkqi3Vi0JVZN1ERh+YP4o6R2CTvEGUrB0qAlJULEIMYYKxFDDU2rBGqXLTOGWcJW0/oj/MGCJmqC1tQqNVSTltoYTaRlmdndYWd3jrmzzHbZDrN3d+9978zL3X822T3vvHPO59333ve++4PgfiJdAYp0di45OMARvwgcYAc44hWIeHquBTvAEa9AxNNzLdgBjngFIp6ea8EOcMQrEPH0XAt2gCNegYin51qwAxzxCkQ8PdeCHeCIVyDi6bkW7AA3TgVGNiVvKzOWM3MHM3WAcTvAS5goASBBzOo3mCgPIE/MeYAugfAKEV8gogse4Xxrb+61xsm6fqQN3YKHNiffyyWsLgOdBO5kxq0mwBDhdQYNeMAA+Tjd3pP7twm/YfhoOMC8eXNiqDTcxUAazKsYdkelEMAgOkNApt1v66eeHtX6G+anYQAXN6c6RsdKu4nRzYy2MCpMhGEm9LU0+/tjPdkLYcQw23OKB1xIpe5ijO0BYR0ze7NN0IY9EZXBOElo3hfPZv9i4xymfIoFXPjyhneXi3wA4JSpZO34oawXo13xnxz/rx3/8/MqDjCfONFUeK5/GwOPAlg0v/QCO3qQgL3xtV2HaP368cDOqnEiUYBH0ullJZRyYP64RuzyTIjO+fCTrZnMq1KCEwM4n+6+j4GnwVgspThzioNwmYAtiUzfs3M63vBBoQOeuCX/7DFG+RHDuYXqjuA9Hl/7xZ1h37JDBcybNsUK4yPHmXFvqDQsnZwIP483tW6g3t6ipVPM6DY0wLx166LC8OBzDHx6xigb2ICA38bbFq2lI0cGw0gjFMDX4J5lYEUYSQd9TgJejLctWhkG5MABV27LYyOnot5yp19ElZbc3Lom6Nt1oIArL1TP958M+pnrr+yE/5lV8G55X6Xu5Tf+hdJvzqB0diDQxlx5Jt/TtS7IF69AAedTGw4G+bZMixYjtu1hNC//UE2QY+f/huKhJ8GDlwMDrd6uE9njO4I6YWCAKzqX0R9UYuo8rd/Ye0O41TgU5JHvq06z4H6I0BWUTg4E8EQP1eifg+zEULfl2JatWtSKTx8J9nZNuOyj5SNB9HhZB6yeu/nnn/190N2Pbd/+Lpre/wEtwOP//AeGv/MtLVtjRkTnEvfc90nbz2PrgPOp7ocZeMJYYTQdxZ/qBcViWtZcLKLw4CYtW5NGBGxPZPueNOmzxtu7PfcTn/zK6sN44F+F4od7QG164wJ4eBiFhzbbK8SNPQ96Ma/D5qdGqy34SiqZCet7btuj+9G0dKkWtPGLFzG8d7eWrXkjyi7M5tLm/U54tAZYjcQoo/SircBn8hvbsRP+3R+byazy/9ILf0Tx4GNatjaMPPgrbI0MsQY4n0r2MXi9jYLo+FyQ2oiWNZ/TMcXoqV/havaYlq0NIwKdSGRz3XZ8W/CqBsiVSmMvhzmGyl/zWcRS92tlV8w+g9KpX2vZ2jBSY7x8v/kOGwP5rLTgKxu7e1DGAzaKoeuz+e6PonXHLi3zkYMHMPbCn7RsrRl5OLrwWJ/xNz3jgNW45UJp6D9hDW2tAvBuXYr27+3X4jH0zd0ov35Ry9aWkRqSG/fb32N63LVxwIV0clOZ+aitQmj7bWtD4nCPlnleSaThYS1bm0Ye0QPxTK7X5DmMA86nk6eZudNkkHP1paOFQ9TA70iLiAYSmdzqueZb6zijgNVcofIov2F7OoluAXS0cLga+PpM1DQZr4VuMTkXyijgQjqZLjOHpzemkdfRwmFr4OkXq0e0MZ7JZXQv4pnsjAK+kk4eBXPwnbo3yFJHC4etgWvcp3sXZnLGFIhRwPl090VTUzhnujJ1/q+jhcPWwNPzUFNXE5k+vT5WjSIYA6wmX5fGWMyIfpW7jhYWoYGngfKbaZmpSejGAA/dn/z8+Dj/QuOiCsxERwtL0MDTC9LURF9ofyb3SxOFMga4sLH7a+Uywuuxr1UNDS0sRQNPDd/zsDN+rO+HogDn08nDzKw3RsZE5Jo+6mlhSRp4ajpEdCSRyT2kmWJdM2MtOJ9KnmHwShNBmfRRTwtL0sDXAQadTWRzq0zUwSDg7pcY+LCJoEz6qKeFpWngat4E/DWR7bvTRB2MAb6STr4K5ttMBGXSRz0tLE4DTxKm1xZmcstM1MEk4P+BeYmJoEz6qKeFpWngybyJLi3M5N5log7GAOdT3VcZaDERlEkf9bSwRA2scidgNJHtW2CiDpEHXE8LS9TAYgFfSSdF3qJRRwtL1MCVVivxFi31JUvVq5YWlqqBrwGW95KVT8mUSapgtbSwVA187RYtTyZJ7ehQBaulhaVq4AnAEjs6hHZVqoLV0sJiNXDlESywq1Lkx4ZrOqOWFhargQGI/Ngg8XNhVUfW0sJSNbCKWeTnQokf/KuAa2lhqRpYxSzyg78KTNqQncmeoBpaWKoGFjtkRxVT2qC7qV197Y//CN7NE13l5TcvYeiRr5roCTTvg0juoDtpw2anVr/pzhWIbXmw8qfi009h/KXQZrbWvShED5uVNvDdfPOy61H8wPeJ57CcqSt2cZj3Ln7qikpZzOQz8/W37rEhJp9JmT5qnYbhEzTM9NHK27SACeCG62/fXaNMAK+8pQpYwsE+EXNnaLglHCovWyEvwjK1/HTTzViw4Uto+uAdlT+P//1lXD3+U/Bbb5qjNA9PDbcIS+VlK+RllKr1VnDb9/0AFI9fh4ALBQzt+boIyA25jFLlWRziQmhVmrGvbIf/iU/VbF+lP/wOxR8HvsritFgadCG0SisOcSnDahXbnzgEb/FNNQGXL7+Foe3b5nFznfehjb2U4cSzOJzFSBsBcMMvRqqKHNZywuJv0VFZTlgVOowFwUW/ZEVpQfBqocNY0n8qZEkyKXJL+k9CDnhTjnm/AllwENlNOarP4zC21bHAaU4uI7+tTgWy2xgr0H0MjU0+m80l7ba2m0215mcbCuBKS3abU86PnObRoQGevF277WU1Uc3NLFTAky9eboPoudHTOCp0wNfpZLfFuway2ZmIAfx2j1cpF/QuabMrWR1ronM+/GQQW9bpxiwK8Nu37P5tDKgdIwPfUEu3cNPsBgnYG1/bdcj2VnWzjU8c4GoCE58a+UBYG2vpF5KyXox22dy9TD+Wd1qKBTwJOpW6izG2B4R1YW7TM7V0agwVGCcJzftsbWg1H6jXxWrKkW0/aiDf6FhpNzG6w9rRRQ1tZUJfS7O/38YeRzZqKL4FT09ajbseKg13MZAG8yrb+0Oo6SQgOkNApt1v6ze97Y0NqA3ZgmsVQs2F4hJWl4FOAneaWm1eTeFk0IAHDJCP0yY3ybANdLr/hmvB9QqkJqGXGcuZuYOZOsC4HeAlTJQAkCBm9RtMlFejiYg5D9AlEF4h4gtEdMEjnDe12nrQMGudL1KAJRRUWgwOsDQihuNxgA0XVJo7B1gaEcPxOMCGCyrNnQMsjYjheBxgwwWV5s4BlkbEcDwOsOGCSnPnAEsjYjgeB9hwQaW5c4ClETEcjwNsuKDS3DnA0ogYjscBNlxQae4cYGlEDMfjABsuqDR3DrA0Iobj+T+8S0i11Vh8SQAAAABJRU5ErkJggg==" alt="">
                    <div class="${type}-title">${title}</div>
                </div>
            </div>
        `;
        document.body.append(dom)
        setTimeout(function (){
            document.getElementById('message-success').remove()
        },1500)
    }


    /**
     * 从url解析搜索参数到对象中
     */
    var decodeQuery = function () {
        var params = {};
        var queryStr = window.location.search.replace(/^\?/, "");
        var queryArr = queryStr.split("&");
        for (var i = 0; i < queryArr.length; i++) {
            var item = queryArr[i].split("=");
            if (item[0] && item[1]) params[item[0]] = decodeURIComponent(item[1]);
        }
        return params;
    }
    // common add cart
    $('.add-cart-btn').wait('.add-cart-btn',function (){


        $('.add-cart-btn').click(function (){
            var _data = {items: [
                    {
                        quantity: 1,
                        id: $(this).data('variantid'),
                    }
                ]}
            console.log(_data)
            loadingShow()
            $.ajax({
                type:'POST',
                url:'/cart/add.js',
                data:_data,
                success:function (addResponse) {
                    $.get("/cart.js",function (response){
                        var _type = window.platform === "mobile"? 'm' : 'p';
                        msgSuccess('ADD CART SUCCESS',_type)
                        var _result = JSON.parse(response)
                        var _itemCount = _result.item_count
                        $('#cart-update-count .item-count').text(_itemCount);
                    })
                },
                error:function (XMLHttpRequest) {
                    var error = JSON.parse(XMLHttpRequest.responseText)
                    var _type = window.platform === "mobile"? 'm' : 'p';
                    msgError("SOLD OUT",_type)
                },
                complete:function (){
                    loadingHide()
                }
            })

        })

    })
    function getCookie(cname)
    {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i=0; i<ca.length; i++)
        {
            var c = ca[i].trim();
            if (c.indexOf(name)==0) return c.substring(name.length,c.length);
        }
        return "";
    }

    if(window.platform === "mobile")
    {
        var discountName = "FIRSTORDERMOBILE"
        var discountUrl = "https://m.vgoglove.com/discount/FIRSTORDERMOBILE"
    }else{
        var discountName = "FIRSTORDER"
        var discountUrl = "https://vgoglove.com/discount/FIRSTORDER"
    }



    // 判断是否已经领取过
    function discountIsGet()
    {
        var landing_cookie = getCookie("discount_code")
        if(landing_cookie === discountName)
        {
            if(!$('#getCoupon').hasClass('drap')) $('#getCoupon').addClass('drap')
            $('#getCoupon').css('filter','grayscale(1)')
            $('#getCoupon').css('cursor','not-allowed')
        }
    }
    discountIsGet()
    $('#getCoupon').on('click', function(){
        if($('#getCoupon').hasClass('drap')) return ;
        var couponUrl = discountUrl;
        $.ajax({
            url:couponUrl,
            type:'get',
            success:function ()
            {
                var _type = window.platform === "mobile"? 'm' : 'p';
                msgSuccess("Success received",_type)
                $('#getCoupon').addClass('drap')
                discountIsGet()
            },
            error:function (){
                var _type = window.platform === "mobile"? 'm' : 'p';
                msgError("already have received",_type)
                discountIsGet()
            }
        })
    });



    //pc login
    var forgetPwd = $('#RecoverPassword');
    var showLogin = $('#HideRecoverPasswordLink');
    forgetPwd.click(function (){
        $('#login-main .quick-go').addClass('hidden');
        $('#CustomerLoginForm').addClass('hidden');
        $('#RecoverPasswordForm').removeClass('hidden');
    });
    showLogin.click(function (){
        $('#login-main .quick-go').removeClass('hidden');
        $('#CustomerLoginForm').removeClass('hidden');
        $('#RecoverPasswordForm').addClass('hidden');
    });


    // pc header
    var pcCategory = $('#pc-big-category .tab');
    console.log('xxx');
    console.log(pcCategory);
    pcCategory.on('click',function (){
        if($('#pc-small-category').hasClass('hidden') && $('#pc-header-mask').hasClass('hidden'))
        {
            $('#pc-small-category').removeClass('hidden');
            $('#pc-header-mask').removeClass('hidden');
        }else{
            $('#pc-small-category').addClass('hidden');
            $('#pc-header-mask').addClass('hidden');
        }
    });
    // mobile center
    var mobileOrder = $('#account .order-icon .icon')
    var hideOrder = $('#order-list .my-orders .left-arrow')
    var orderList = $('#order-list .orders .tabs .tab')
    var customer = $('#account .service .support')
    var productCustomer = $('#mobile-product .customer-server')
    mobileOrder.on('click',function (){
        $('#order-list').removeClass('hidden')
        $('#mobile-header').addClass('hidden')
    });
    hideOrder.on('click',function (){
        $('#order-list').addClass('hidden')
        $('#mobile-header').removeClass('hidden')
    });
    orderList.on('click',function (){
        var _hdom = ".select-tab"+$(this).data('id')
        var _list_tab = '#order-list .orders .list-tab'
        var _list = '#order-list .orders .list '+_hdom
        $(_list_tab).addClass('hidden');
        $(_list).removeClass('hidden');
        orderList.removeClass('tab-active')
        $(this).addClass('tab-active')
    });
    function toggleShopifyChat()
    {
        var shopCart = $('#shopify-chat');
        console.log(shopCart);
        if(shopCart.hasClass('hidden'))
        {
            shopCart.removeClass('hidden');
        }else{
            shopCart.addClass('hidden');
        }
    }
    customer.on('click',function (){
        toggleShopifyChat()
    });
    productCustomer.on('click',function (){
        toggleShopifyChat()
    });

    // pc center
    var pcOrder = $('#account .account-info .my-orders .icon')
    pcOrder.on('click',function (){
        $('#account .account-center').addClass('hidden');
        $('#account .my-orders').removeClass('hidden');
    });

    // pc order tab
    var pcOrderList = $('.pc-account-menus .menus .sm-title')
    function tabChoose(dom,text)
    {
        var _list_tab = '#account .my-orders .list-tab'
        var _list = '#account .my-orders .list '+dom
        $(_list_tab).addClass('hidden');
        $(_list).removeClass('hidden');
        $('.my-orders .order-title').text(text);
        pcOrderList.removeClass('tab-active')
    }
    pcOrderList.on('click',function (){
        $('#account .account-center').addClass('hidden');
        $('#account .my-orders').removeClass('hidden');
        var _type = $(this).data('type')
        var _htext = $(this).text()
        if(_type === 'order-detail')
        {
            window.location.href = "/account?tab="+$(this).data('id')+"&text="+_htext
        }else {
            var _hdom = ".select-tab"+$(this).data('id')
            tabChoose(_hdom,_htext)
            $(this).addClass('tab-active')
        }
    });
    if(window.location.pathname === "/account")
    {
        var query = decodeQuery()
        if(typeof (query.tab) !== "undefined"){
            var _hdom = ".select-tab"+query.tab
            tabChoose(_hdom,query.text)
        }
    }

    // product detail
    var variantsChoose = $('.product-variants .variants-item');
    variantsChoose.on('click',function (){
        var disable = $(this).data('disable')
        if(disable === false)
        {
            return ;
        }
        var variantId = $(this).data('id')
        var selected = "variant="+$(this).data('selected_id')
        if(window.location.search === "")
        {
            window.location.href = window.location.pathname+'?variant='+variantId
        }else {
            var newSelected = "variant="+variantId;
            var reg = RegExp(/variant/);
            if(reg.test(window.location.search))
            {
                var search = window.location.search.replace(selected,newSelected);
                window.location.href = window.location.pathname+search
            }else{
                window.location.href = window.location.href+"&"+newSelected
            }
        }
    })

    // change address for city

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify && Shopify.CountryProvinceSelector) {
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(
            'AddressCountryNew',
            'AddressProvinceNew',
            {
                hideElement: 'AddressProvinceContainerNew'
            }
        );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
        var formId = $(this).data('form-id');
        console.log(formId)
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;

        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector
        });
    });


    // mobile category detail
    $('#m-category-big-img').wait('#m-category-big-img',function () {
        var query = decodeQuery()
        var set = document.getElementById('m-category-big-img').getAttribute('data-'+query.ckey)
        document.getElementById('m-category-big-img').setAttribute('src',set)
    });

});